// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "962408b95182";
export const BUILD_VERSION_NUMBER = 80;
